export default {
	name	: "custom-html-widget",
	props	: {
		widget: {
			type		: Object,
			required	: true,
		},
	},
	computed: {
		variables() {
			return this.widget && this.widget.variables ? this.widget.variables : {};
		},
		content() {
			return this.widget && this.widget.content ? this.widget.content : "";
		},
		closable() {
			// Strictly opt-in: course-targeted records may reach the host
			// without closable — they must not grow a dismiss control.
			return this.variables.closable === true;
		},
		closeLabel() {
			// $t може бути відсутній/без ключа — фолбек на укр. дефолт,
			// як у решті widget-шаблонів (єдиний i18n-підхід — у беклозі)
			try {
				const translated = this.$t && this.$t("widgetClose");
				return translated && translated !== "widgetClose" ? translated : "Закрити";
			} catch (e) {
				return "Закрити";
			}
		},
	},
	methods: {
		onDismiss() {
			this.$emit("dismiss");
		},
	},
};
